
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64.988 50.462"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.885 49.494a3.317 3.317 0 01-4.692 0L1.458 30.752a4.975 4.975 0 010-7.038L3.8 21.368a4.976 4.976 0 017.038 0l11.7 11.7 31.608-31.61a4.976 4.976 0 017.038 0l2.346 2.347a4.975 4.975 0 010 7.038zm0 0","fill":"#42ddb3"}})])
          )
        }
      }
    